'use client';

import { useCountryAndCurrency } from '@/hooks/country/useCountryAndCurrency';
import usePublicEnvVars from '@/hooks/usePublicEnvVars';
import { privacyPolicyLinkMap } from '@/lib/consts/countrySpecificLinks';
import { formatBrand } from '@/utils/brand-client';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

const LoginFormFooter = () => {
  const t = useTranslations('LoginPage');
  const { country } = useCountryAndCurrency();
  const { brand } = usePublicEnvVars();

  return (
    <>
      <p className="text-xs">
        {t('privacyPolicyDescription', { brand: formatBrand(brand) })}
        <Link className="underline" href={privacyPolicyLinkMap[country]}>
          {t('privacyPolicy')}
        </Link>
      </p>
    </>
  );
};

export default LoginFormFooter;
